function stat(value, label, live) {
  if (live === void 0) {
    live = false;
  }
  return m('div.dc-stat', [m('b', live ? [m('span.dc-dot.dc-dot--live'), Number(value || 0).toLocaleString('ru-RU')] : Number(value || 0).toLocaleString('ru-RU')), m('span', label)]);
}
function codeWindow() {
  return m('div.dc-hv.dc-hv--code', [m('div.dc-hv__bar', [m('span.dc-hv__dot', {
    style: 'background:#f87171'
  }), m('span.dc-hv__dot', {
    style: 'background:#fbbf24'
  }), m('span.dc-hv__dot', {
    style: 'background:#34d399'
  }), m('span.dc-hv__file', 'deploy.ts')]), m('pre.dc-hv__code', [m('span.tk-c', '// deploy.ts · prod\n'), m('span.tk-k', 'const '), 'deploy = ', m('span.tk-k', 'async '), '(app: ', m('span.tk-t', 'AppName'), ') => {\n', '  ', m('span.tk-k', 'await '), 'docker.', m('span.tk-f', 'build'), '(app, { cache: ', m('span.tk-b', 'true'), ' });\n', '  ', m('span.tk-k', 'await '), 'k8s.', m('span.tk-f', 'apply'), '(`infra/${app}.yaml`);\n', '  ', m('span.tk-k', 'return '), m('span.tk-f', 'notify'), '(', m('span.tk-s', "'Деплой завершён ✓'"), ');\n};'])]);
}

// Карточка конвейера заполняет большую стеклянную плоскость полезным сценарием из жизни разработчика.
// Данные здесь демонстрационные: они объясняют специализацию сообщества и не притворяются реальной телеметрией сайта.
function deliveryPipeline() {
  return m('div.dc-hv-glass.dc-hv-glass--a', [m('div.dc-hv-pipeline__head', [m('span.dc-dot.dc-dot--live'), m('b', 'CI/CD · main'), m('small', '1:42')]), m('div.dc-hv-pipeline__steps', [m('span.is-done', [m('i', '✓'), 'Тесты']), m('span.is-done', [m('i', '✓'), 'Сборка']), m('span.is-live', [m('i'), 'Production'])])]);
}

// Карточка показывает проверяемый результат сообщества вместо выдуманного SLA.
// Значение приходит из той же базы, где хранится accepted_post_id каждой решённой темы.
function solutionCard(stats) {
  return m('div.dc-hv-glass.dc-hv-glass--b', [m('div.dc-hv-reliability', [m('span.dc-hv-reliability__icon', '✓'), m('div.dc-hv-reliability__value', [m('b', Number(stats.solutions || 0).toLocaleString('ru-RU')), m('span', 'решений принято')]), m('small', 'по реальным ответам сообщества')])]);
}
export default function Hero(_ref) {
  let {
    stats,
    spaces,
    configuration = {}
  } = _ref;
  return m('section.dc-hero', [m('div.dc-hero__dots', {
    'aria-hidden': 'true'
  }), m('div.dc-container.dc-hero__grid', [m('div.dc-hero__content', [m('div.dc-hero__badge', [m('span.dc-dot.dc-dot--live'), ' DevConnect · сообщество разработчиков']), m('h1.dc-hero__title#dc-portal-title', configuration.title || 'Задавайте вопросы. Находите решения.'), m('p.dc-hero__text', configuration.description || 'Практическое сообщество о разработке, серверах и безопасности. Здесь помогают разобраться в задаче понятным языком и делятся рабочим опытом.'), m('div.dc-hero__ctas', [m('a.dc-btn.dc-btn--primary.dc-btn--lg', {
    href: '/all'
  }, 'Начать обсуждение'), m('a.dc-btn.dc-btn--soft.dc-btn--lg', {
    href: '/guides'
  }, 'Открыть инструкции')]), m('div.dc-hero__stats', [stat(stats.users, 'участников'), stat(stats.discussions, 'обсуждений'), stat(stats.posts, 'сообщений'), stat(stats.online, 'сейчас онлайн', true)])]), m('div.dc-hero__visual', {
    'aria-hidden': 'true'
  }, [deliveryPipeline(), solutionCard(stats), m('span.dc-fchip', {
    style: 'left:212px;top:6px;--fc:#3178c6'
  }, 'TypeScript'), m('span.dc-fchip', {
    style: 'right:8px;top:224px;--fc:#0891b2'
  }, 'Docker'), m('span.dc-fchip', {
    style: 'left:-6px;bottom:150px;--fc:#7c3aed'
  }, 'PHP'), m('span.dc-fchip', {
    style: 'left:250px;bottom:-4px;--fc:#0891b2'
  }, 'React'), codeWindow(), m('div.dc-hv.dc-hv--reply', [m('div.dc-hv__label', [m('span.dc-dot.dc-dot--live'), ' Новый ответ']), m('div.dc-hv__title', 'Практический вопрос получил свежий ответ сообщества'), m('div.dc-hv__foot', 'только что')]), m('div.dc-hv.dc-hv--solved', [m('span.dc-hv__check', '✓'), m('div', [m('b', 'Решение принято'), m('small', '+15 к рейтингу')])])])]), m('div.dc-container', m('div.dc-trending', [m('div.dc-trending__label', [m('span.dc-dot.dc-dot--pulse'), ' Сейчас обсуждают']), m('div.dc-trending__chips', (spaces || []).slice(0, 7).map(space => m('a.dc-trend-chip', {
    href: space.url,
    key: space.url
  }, [`#${space.name} `, m('span', space.discussionCount)])))]))]);
}
flarum.reg.add('devconnect-portal', 'forum/components/Hero', Hero);